/**
 * Indicateur de progression du tournoi live (donne X/Y).
 * En phase d'attente, une seconde barre indique les joueurs ayant fini la donne.
 */

interface DonneCounterProps {
  current: number;
  max: number;
  playersFinished?: { finished: number; total: number } | null;
  variant?: 'overlay' | 'inline';
}

export default function DonneCounter({
  current,
  max,
  playersFinished,
  variant = 'overlay',
}: DonneCounterProps) {
  const dealPct = max > 0 ? Math.min(100, (current / max) * 100) : 0;
  const showPlayers = Boolean(playersFinished && playersFinished.total > 0);
  const playersPct = showPlayers && playersFinished
    ? Math.min(100, (playersFinished.finished / playersFinished.total) * 100)
    : 0;

  const ariaLabel = showPlayers && playersFinished
    ? `Donne ${current} sur ${max}, ${playersFinished.finished} joueurs sur ${playersFinished.total} ont terminé`
    : `Donne ${current} sur ${max}`;

  return (
    <div
      className={`donne-counter${variant === 'inline' ? ' donne-counter--inline' : ''}`}
      role="status"
      aria-label={ariaLabel}
    >
      <span className="donne-counter-label">Donne</span>
      <span className="donne-counter-value">{current}/{max}</span>
      <div className="donne-counter-bar" aria-hidden>
        <div className="donne-counter-fill" style={{ width: `${dealPct}%` }} />
      </div>
      {showPlayers && playersFinished && (
        <>
          <span className="donne-counter-players">
            {playersFinished.finished}/{playersFinished.total} joueurs
          </span>
          <div className="donne-counter-bar donne-counter-bar--players" aria-hidden>
            <div
              className="donne-counter-fill donne-counter-fill--players"
              style={{ width: `${playersPct}%` }}
            />
          </div>
        </>
      )}
    </div>
  );
}
